import { get, set, omit, slice } from 'lodash';
import * as ACTION_TYPES from '../constants/ACTION_TYPES';

const initialState: PaginationState = {
  paginations: {},
};

const MIN_PAGE = 0;
const MIN_SIZE = 0;

export const getPaginationByKey = (state: PaginationState) => (key: string) =>
  state.paginations[key];

export const getPaginationPageByKey = (state: PaginationState) => (
  key: string
) => get(state.paginations, `${key}.page`, MIN_PAGE);

export const getPaginationSizeByKey = (state: PaginationState) => (
  key: string
) => get(state.paginations, `${key}.size`, MIN_SIZE);

export const getPaginationSliceByKey = (state: PaginationState) => (
  key: string
) => {
  const pg = state.paginations[key];
  if (!pg) return [];
  const offset = pg.page * pg.size;
  return slice(
    pg.list,
    Math.max(MIN_PAGE, offset),
    Math.min(pg.list.length, offset + pg.size)
  );
};

function handlePaginationCreate(
  state: PaginationState,
  action: CreatePaginationAction
): PaginationState {
  return {
    ...state,
    paginations: set({ ...state.paginations }, action.payload.key, {
      list: action.payload.list,
      size: action.payload.size,
      page: MIN_PAGE,
    }),
  } as PaginationState;
}

function handlePaginationDelete(
  state: PaginationState,
  action: DeletePaginationAction
): PaginationState {
  return {
    ...state,
    paginations: omit({ ...state.paginations }, action.payload.key),
  } as PaginationState;
}

function handlePaginationSetSize(
  state: PaginationState,
  action: SetPageSizeAction
): PaginationState {
  return {
    ...state,
    paginations: set({ ...state.paginations }, action.payload.key, {
      ...state.paginations[action.payload.key],
      size: action.payload.size,
    }),
  } as PaginationState;
}

function handlePaginationJumpToPage(
  state: PaginationState,
  action: JumpToPageAction
): PaginationState {
  return {
    ...state,
    paginations: set({ ...state.paginations }, action.payload.key, {
      ...state.paginations[action.payload.key],
      page: action.payload.page,
    }),
  } as PaginationState;
}

export default function pagination(
  state: PaginationState = initialState,
  action: Action
): PaginationState {
  switch (action.type) {
    case ACTION_TYPES.PAGINATION_CREATE:
      return handlePaginationCreate(state, action as CreatePaginationAction);
    case ACTION_TYPES.PAGINATION_DELETE:
      return handlePaginationDelete(state, action as DeletePaginationAction);
    case ACTION_TYPES.PAGINATION_SET_SIZE:
      return handlePaginationSetSize(state, action as SetPageSizeAction);
    case ACTION_TYPES.PAGINATION_JUMP_TO_PAGE:
      return handlePaginationJumpToPage(state, action as JumpToPageAction);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/pagination.ts